import { Chip } from "@mui/material";

const statusStyles = {
  ACTIVE: {
    color: "success",
    label: "Active",
  },
  INACTIVE: {
    color: "default",
    label: "Inactive",
  },
};

const EventStatusChip = ({ status }) => {
  const normalizedStatus = status?.toUpperCase();
  const config = statusStyles[normalizedStatus] || statusStyles.INACTIVE;

  return (
    <Chip
      size="small"
      label={config.label}
      color={config.color}
      variant={normalizedStatus === "ACTIVE" ? "filled" : "outlined"}
      sx={{ fontWeight: 600 }}
    />
  );
};

export default EventStatusChip;
